function listenToChartDelete() {
  document.querySelectorAll('.remove-chart').forEach(function (button) {
    button.addEventListener('click', function () {
      const chartNodeId = button.getAttribute('data-chart-node-id');
      const parentDiv = button.closest('.chart-parent-js');
      if (parentDiv) {
        parentDiv.remove();
      }

      fetch(`/api/chart/update-favorite-chart?chartNodeId=${chartNodeId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then(async (response) => {
          if (!response.ok) {
            throw new Error('Failed to remove chart from favorites.');
          }

          const addListPromise = fetch(`/account/chartAddList?pageIndex=0`)
            .then((r) => {
              return r.text();
            })
            .then((html) => {
              document.getElementById('charts-add-list').innerHTML = html;
              listenToAddChartDelete();
              attachPaginationEventListeners();
            });

          const chartListPromise = fetch(`/account/chartList?count=4`)
            .then((r) => {
              return r.text();
            })
            .then((html) => {
              document.getElementById('chart-list').innerHTML = html;
              listenToChartDelete();
            });

          await Promise.all([addListPromise, chartListPromise]);
        })
        .catch((error) => {
          console.error('Error removing chart:', error);
        });
    });
  });
}

document.addEventListener('DOMContentLoaded', () => listenToChartDelete());

document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('.filter')) {
    const filterHeading = document.querySelector('.filter h5');
    const navList = document.querySelector('.filter ul.nav');

    filterHeading.addEventListener('click', () => {
      navList.classList.toggle('open');
    });
  }
});

function listenToAddChartDelete() {
  document
    .querySelectorAll('#addchart .btn[data-node-id]')
    .forEach(function (button) {
      button.addEventListener('click', function () {
        const chartNodeId = button.getAttribute('data-node-id');
        const currentText = button.textContent.trim();
        const alternateText = button.getAttribute('data-alternate-text');

        button.textContent = alternateText;
        button.setAttribute('data-alternate-text', currentText);

        fetch(`/api/chart/update-favorite-chart?chartNodeId=${chartNodeId}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error('Failed to update chart status.');
            }

            fetch(`/account/chartList?count=4`)
              .then((r) => {
                return r.text();
              })
              .then((html) => {
                document.getElementById('chart-list').innerHTML = html;
                listenToChartDelete();
              });
          })
          .catch(() => {
            button.textContent = currentText;
            button.setAttribute('data-alternate-text', alternateText);
          });
      });
    });
}
document.addEventListener('DOMContentLoaded', () => listenToAddChartDelete());

function attachPaginationEventListeners() {
  const paginationLinks = document.querySelectorAll('#addchart .pagination a');
  // Remove previous listeners by cloning nodes
  paginationLinks.forEach((link) => {
    link.replaceWith(link.cloneNode(true));
  });
  // Re-select the nodes after cloning
  const refreshedPaginationLinks = document.querySelectorAll(
    '#addchart .pagination a'
  );
  refreshedPaginationLinks.forEach((link) => {
    link.addEventListener('click', function (event) {
      event.preventDefault(); // Prevent default request
      // Extract pageIndex from the link's href
      const urlObj = new URL(this.href, window.location.origin);
      const pageIndex = urlObj.searchParams.get('pageIndex');

      // Get active filter value if exists
      const activeFilterLink = document.querySelector(
        '.filter .nav-link.active'
      );
      const filterValue = activeFilterLink
        ? activeFilterLink.textContent.trim()
        : '';

      // Build a new URL with separate pageIndex and filter parameters
      let newUrl =
        '/account/chartAddList?pageIndex=' + encodeURIComponent(pageIndex);
      if (filterValue) {
        newUrl += '&filter=' + encodeURIComponent(filterValue);
      }
      fetchChartList(newUrl, filterValue);
    });
  });
}
function fetchChartList(url, filterValue) {
  fetch(url)
    .then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.text();
    })
    .then((html) => {
      document.getElementById('charts-add-list').innerHTML = html;

      // If a filter is active, update the title (if element exists)
      if (filterValue) {
        const title = document.getElementById('addchart-filter-name');
        if (title) {
          title.innerText = filterValue;
        }
      }
      // Reattach event listeners after the DOM update
      attachFilterEventListeners();
      attachPaginationEventListeners();
      listenToAddChartDelete();
    })
    .catch((error) => {
      console.error('Error fetching chart list:', error);
    });
}

function attachFilterEventListeners() {
  const filterLinks = document.querySelectorAll('.filter .nav-link');
  // Remove previous listeners by cloning the nodes
  filterLinks.forEach((link) => {
    link.replaceWith(link.cloneNode(true));
  });
  // Re-select the nodes after cloning
  const refreshedFilterLinks = document.querySelectorAll('.filter .nav-link');
  refreshedFilterLinks.forEach((link) => {
    link.addEventListener('click', function (event) {
      event.preventDefault(); // Prevent default navigation
      // Remove active class from all, then add to the clicked link
      refreshedFilterLinks.forEach((l) => l.classList.remove('active'));
      this.classList.add('active');

      const filterValue = this.textContent.trim();
      // Start on the first page when filter changes
      const url =
        '/account/chartAddList?pageIndex=0&filter=' +
        encodeURIComponent(filterValue);
      fetchChartList(url, filterValue);
    });
  });
}
document.addEventListener('DOMContentLoaded', function () {
  attachFilterEventListeners();
  attachPaginationEventListeners();
});

document.addEventListener('DOMContentLoaded', () => {
  // Select the dropdown and the target anchor
  const dropdown = document.getElementById('dashboard-dropdown');
  const dashboardLink = document.getElementById('subnav-dropdown');

  if (dropdown && dashboardLink) {
    // Toggle dropdown function
    const toggleDropdown = function () {
      document.querySelector('.subnav .nav').classList.toggle('scroll');
      dropdown.classList.toggle('show');
    };

    // Toggle dropdown open/close when dropdown button is clicked
    dashboardLink.addEventListener('click', function (e) {
      e.stopPropagation();
      toggleDropdown();
    });

    // Close dropdown when dom element is clicked
    document.documentElement.addEventListener('click', function () {
      if (dropdown.classList.contains('show')) {
        toggleDropdown();
      }
    });
  }
});

document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('.subnav')) {
    document.querySelector('.site-header')?.classList.remove('sticky-top');
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const parentId = 'intro-dash-content';

  const parent = document.getElementById(parentId);
  if (!parent) return;

  const btn = parent.querySelector('button#intro-dash-content-close-button');
  if (!btn) return;

  btn.addEventListener('click', (e) => {
    e.preventDefault();
    parent.remove();
    fetch('/account/hide-intro', { method: 'POST' });
  });
});
